// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file Enumerations/BusinessLocationSearchBy.proto (package time_tracking.enumerations, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc } from "@bufbuild/protobuf/codegenv2";
import { file_Options_EnumValueOptions } from "../Options/EnumValueOptions_pb";

/**
 * Describes the file Enumerations/BusinessLocationSearchBy.proto.
 */
export const file_Enumerations_BusinessLocationSearchBy: GenFile = /*@__PURE__*/
  fileDesc("CitFbnVtZXJhdGlvbnMvQnVzaW5lc3NMb2NhdGlvblNlYXJjaEJ5LnByb3RvEhp0aW1lX3RyYWNraW5nLmVudW1lcmF0aW9ucyqjAgoYQnVzaW5lc3NMb2NhdGlvblNlYXJjaEJ5EjEKJUJVU0lORVNTX0xPQ0FUSU9OX1NFQVJDSF9CWV9URU5BTlRfSUQQABoGysfNDwEDEjUKKUJVU0lORVNTX0xPQ0FUSU9OX1NFQVJDSF9CWV9CVVNJTkVTU19OQU1FEAEaBsrHzQ8BBRIsCiBCVVNJTkVTU19MT0NBVElPTl9TRUFSQ0hfQllfTkFNRRACGgbKx80PAQYSMwonQlVTSU5FU1NfTE9DQVRJT05fU0VBUkNIX0JZX0RFU0NSSVBUSU9OEAMaBsrHzQ8BBxI6Ci5CVVNJTkVTU19MT0NBVElPTl9TRUFSQ0hfQllfRVhURVJOQUxfUkVGRVJFTkNFEAQaBsrHzQ8BCEIoqgIlTW9naS5UaW1lVHJhY2tpbmcuQ29tbW9uLkVudW1lcmF0aW9uc2IGcHJvdG8z", [file_Options_EnumValueOptions]);

/**
 * Determines which columns of a business location can be used for text search.
 *
 * @generated from enum time_tracking.enumerations.BusinessLocationSearchBy
 */
export enum BusinessLocationSearchBy {
  /**
   * Search through the tenant id of a business location.
   *
   * @generated from enum value: BUSINESS_LOCATION_SEARCH_BY_TENANT_ID = 0;
   */
  TENANT_ID = 0,

  /**
   * Search through the name of the business a business location belongs to.
   *
   * @generated from enum value: BUSINESS_LOCATION_SEARCH_BY_BUSINESS_NAME = 1;
   */
  BUSINESS_NAME = 1,

  /**
   * Search through the name of a business location.
   *
   * @generated from enum value: BUSINESS_LOCATION_SEARCH_BY_NAME = 2;
   */
  NAME = 2,

  /**
   * Search through the description of a business location.
   *
   * @generated from enum value: BUSINESS_LOCATION_SEARCH_BY_DESCRIPTION = 3;
   */
  DESCRIPTION = 3,

  /**
   * Search through the external reference text of a business location.
   *
   * @generated from enum value: BUSINESS_LOCATION_SEARCH_BY_EXTERNAL_REFERENCE = 4;
   */
  EXTERNAL_REFERENCE = 4,
}

/**
 * Describes the enum time_tracking.enumerations.BusinessLocationSearchBy.
 */
export const BusinessLocationSearchBySchema: GenEnum<BusinessLocationSearchBy> = /*@__PURE__*/
  enumDesc(file_Enumerations_BusinessLocationSearchBy, 0);

